import { render, staticRenderFns } from "./EmptySearchPhrasesReport.vue?vue&type=template&id=ce338482"
import script from "./EmptySearchPhrasesReport.vue?vue&type=script&lang=ts"
export * from "./EmptySearchPhrasesReport.vue?vue&type=script&lang=ts"
import style0 from "./EmptySearchPhrasesReport.vue?vue&type=style&index=0&id=ce338482&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports